export const RAZORPAY_SUCCESS_BUTTON_ID = "razorpay-success-button";

const RAZORPAY_ROOT_SELECTOR = ".razorpay-container";
const RAZORPAY_SUCCESS_BUTTON_SELECTOR =
  'button.success, button[data-val="S"]';

const getRazorpayRoots = () =>
  Array.from(document.querySelectorAll(RAZORPAY_ROOT_SELECTOR));

const tagRazorpaySuccessButtons = () => {
  const roots = getRazorpayRoots();
  if (!roots.length) {
    return;
  }

  roots.forEach((root) => {
    const buttons = root.querySelectorAll(RAZORPAY_SUCCESS_BUTTON_SELECTOR);
    buttons.forEach((button, index) => {
      if (index === 0) {
        if (!button.id) {
          button.id = RAZORPAY_SUCCESS_BUTTON_ID;
        }
        return;
      }

      if (!button.hasAttribute("data-razorpay-success-button")) {
        button.setAttribute("data-razorpay-success-button", String(index + 1));
      }
    });
  });
};

export const observeRazorpaySuccessButton = () => {
  tagRazorpaySuccessButtons();

  const observer = new MutationObserver(tagRazorpaySuccessButtons);
  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
};
